import { render, staticRenderFns } from "./MediaManager.vue?vue&type=template&id=05dd0212&"
import script from "./MediaManager.vue?vue&type=script&lang=js&"
export * from "./MediaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports